<template functional>
    <a :href="props.url" :target="props.target"><slot>{{props.text}}</slot></a>
</template>
<script>
export default {
    name: 'oc-link',
    props: {
        url: {
            type: String,
            default: 'javascript:;'
        },
        target: {
            type: String,
            default: '_self'
        },
        text: {
            type: [String, Number]
        }
    }
}
</script>
